module.exports = __webpack_public_path__ + "img/hospital4.44378bf3.png";